import { render, staticRenderFns } from "./resultInfo.vue?vue&type=template&id=234e4281&"
import script from "./resultInfo.vue?vue&type=script&lang=js&"
export * from "./resultInfo.vue?vue&type=script&lang=js&"
import style0 from "./resultInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports